export const queryKeys = {
  labelMasterSearch: (keyword?: string) =>
    keyword ? ['labelMasters', 'search', keyword] : ['labelMasters', 'search'],
  labelMastersByIds: (ids: string[]) => [
    'labelMasters',
    'byIds',
    ...ids.sort(),
  ],
  labelInspectionResults: (ids: string[]) => [
    'labelInspectionResults',
    ...ids.sort(),
  ],
}
